<!--添加费用-->
<template>
  <div class="batchAddFee">
    <div v-loading="loading" class="addTable">
      <!--基本信息-->
      <div v-if="addType === 2">
        <el-card class="mb5">
          <div slot="header">
            <span>{{ $t('collectionCenter.basicInformation') }}</span>
          </div>
          <BasicInfoForm
            :type="type"
            :add-batch-fee="addBatchFee"
          />
        </el-card>
      </div>

      <!--费用汇总-->
      <el-card class="mb5">
        <div slot="header">
          <span>{{ $t('receivablePayable.CostSummary') }}</span>
        </div>

        <BasicTable
          v-if="type === 1"
          ref="basicTableRef"
          :add-type="addType"
          :query-form="queryForm"
          :query-fee-param="queryFeeParam"
          :fee-type-option="feeTypeOption"
          :expense-sub-list="addBatchFee.expenseSubList"
        />

        <VehicleTable
          v-if="type === 2"
          ref="vehicleTableRef"
          :add-type="addType"
          :query-form="queryForm"
          :query-fee-param="queryFeeParam"
          :fee-type-option="feeTypeOption"
          :vehicle-expense-sub-list="addBatchFee.vehicleExpenseSubList"
        />
      </el-card>

      <!--费用明细-->
      <el-card v-if="type === 2" class="mb5">
        <div slot="header">
          <span>{{ $t('receivablePayable.FeeBreakdown') }}</span>
        </div>

        <VehicleFeeTable
          :table-list="addBatchFee.vehicleExpenseLoadInfoVOList"
        />
      </el-card>
    </div>

    <div class="footer">
      <!--关闭-->
      <el-button @click="saveData(1)">{{ $t('collectionCenter.close') }}</el-button>
      <!--保存-->
      <el-button v-if="type === 1" type="primary" @click="saveData(2)">{{ $t('basicData.Save') }}</el-button>
    </div>
  </div>
</template>

<script>
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import {
  apiGetSubsByWaybillNumber,
  apiSiteExpenseAddFeeSub,
  apiSiteExpenseAddMultiFeeSub,
  apiVehicleExpenseInfo
} from '@/api/finance/receivables';
import BasicInfoForm from './FeeDetail/basicInfoForm.vue';
import BasicTable from './FeeDetail/basicTable.vue';
import VehicleTable from './FeeDetail/vehicleTable.vue';
import VehicleFeeTable from './FeeDetail/vehicleFeeTable.vue';

export default {
  name: 'BatchAddFee',
  components: {
    BasicInfoForm,
    BasicTable,
    VehicleTable,
    VehicleFeeTable
  },
  props: {
    // 1 快递应收 2 整车应收
    type: {
      type: Number,
      default: 1
    },
    // 当前选中的值
    queryFeeParam: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 费用列表
    feeTypeOption: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // from参数
    queryForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 选择列
    selectData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 1: 单票添加费用 2：费用详情-单票添加费用
    addType: {
      type: Number,
      default: 1
    }
  },
  data() {
    const priceType = (rule, value, callback) => {
      const reg = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };
    return {
      priceType,
      tableHeight: 200,
      total: 0,
      addBatchFee: {
        expenseSubList: [],
        vehicleExpenseSubList: [],
        vehicleExpenseLoadInfoVOList: []
      },
      createUser: null,
      loading: false,
      debounceTimer: null
    };
  },
  watch: {
    'queryFeeParam.id': {
      handler(val) {
        // 清除之前的定时器
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }

        // 防抖处理
        this.debounceTimer = setTimeout(() => {
          if (val && !this.loading) {
            this.getDetail();
          }
        }, 300);
      }
    }
  },

  created() {
    this.createUser = getUserIdAndNameObj();
    const { waybillNumber, settlementNumber } = this.queryFeeParam;
    if (waybillNumber || settlementNumber) {
      this.getDetail();
    }
  },

  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },

  methods: {
    // 1关闭，2保存
    async saveData(type) {
      if (type === 2) {
        if (this.type === 1) {
          await this.$refs.basicTableRef.getFeeTypeOption().then(res => {
            console.log(res, '快递');
            if (!res) {
              return;
            }
            this.addBatchFee.expenseSubList = res;
          });
        }
        if (this.type === 2) {
          await this.$refs.vehicleTableRef.getFeeTypeOption().then(res => {
            console.log(res, '整车');
            if (!res) {
              return;
            }
            this.addBatchFee.vehicleExpenseSubList = res;
          });
        }
        console.log(this.addBatchFee, '参数');
        // return;
        // 限制单条-批量新增
        if (this.addType === 1) {
          const ids = this.selectData.map(item => item.id);
          this.addBatchFee.expenseSubList.forEach(item => {
            delete item.feeTypeOptionList;
          });
          const param = {
            condition: this.queryForm,
            expenseSubList: this.addBatchFee.expenseSubList,
            vehicleExpenseSubList: this.addBatchFee.vehicleExpenseSubList,
            vehicleExpenseLoadInfoVOList: this.addBatchFee.vehicleExpenseLoadInfoVOList
          };
          param.condition.ids = ids;
          console.log(param, '提交参数');
          // return;
          const API = this.type === 1 ? apiSiteExpenseAddFeeSub : '';
          API(param).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('collectionCenter.SaveSuccessfully')); // '保存成功'
              this.$emit('saveForm', type);
            }
          }).catch(err => {
            console.error(err);
          });
        } else {
          // 费用详情新增批量
          const list = [];
          this.addBatchFee.expenseSubList.map(item => {
            if (item.isEdit) {
              list.push(item);
            }
          });
          this.addBatchFee.vehicleExpenseSubList.map(item => {
            if (item.isEdit) {
              list.push(item);
            }
          });
          let param = {};
          if (this.type === 1) {
            param = {
              waybillNumber: this.queryFeeParam.waybillNumber,
              orderNumber: this.queryFeeParam.orderNumber,
              expenseSubList: list
            };
          } else {
            console.log(param, '整车参数');
          }
          const API = this.type === 1 ? apiSiteExpenseAddMultiFeeSub : '';
          API(param).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('collectionCenter.SaveSuccessfully')); // '保存成功'
              this.$emit('saveForm', type);
            }
          });
        }
      } else {
        this.$emit('saveForm');
      }
    },

    // 费用详情
    getDetail() {
      try {
        this.loading = true;
        const API = this.type === 1 ? apiGetSubsByWaybillNumber : apiVehicleExpenseInfo;
        const param = this.type === 1 ? this.queryFeeParam : this.queryFeeParam.id;
        API(param).then(res => {
          const { code, data } = res;
          if (code === 200) {
            const { expenseSubList = [], vehicleExpenseSubList = [], vehicleExpenseLoadInfoVOList = [] } = data;
            if (this.type === 2) {
              vehicleExpenseSubList.map(item => {
                item['isEdit'] = false;
              });
            } else {
              expenseSubList.map(item => {
                item['isEdit'] = false;
              });
            }
            this.addBatchFee = {
              ...data,
              expenseSubList,
              vehicleExpenseSubList,
              vehicleExpenseLoadInfoVOList,
              remark: this.queryFeeParam.remark
            };
            console.log(this.addBatchFee, '详情');
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.batchAddFee {
  padding: 0 10px;

  .addTable {
    height: calc(100vh - 135px);
    overflow-y: scroll;
  }

  .footer {
    padding: 10px;
    text-align: right;
    border-top: 1px solid #ccc;
  }
}

.el-form-item {
  margin-bottom: 0;
}
</style>
